import axios from "axios";
import { Hosts } from "./config";
import router from "../router";
import { getStorageSync, setStorageSync, Falert } from "../unitl/common";
import { constant } from "../unitl/constant";
//   90392712fde711e8977600163e049540  18a5c5f8feb811e881ae00163e049540 9af61adcff9711e88dc300163e049540

// if (process.env.NODE_ENV !== "production") {
//   setStorageSync(
//     constant.token,
//     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvYXBpLmx6ZGV2LjkxZG91YmEuY29tXC9hcGlcL3YxXC93ZWNoYXRcL2xvZ2luIiwiaWF0IjoxNTg3NjkyODM2LCJleHAiOjE1OTI4NzY4MzYsIm5iZiI6MTU4NzY5MjgzNiwianRpIjoib2YxRTBjSXNJUTBSZUhVUyIsInN1YiI6NCwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyIsInJvbGUiOiJ1c2VyIn0.zrvOmDDJtBKuqXx-c-1XX57WmNJUtgax-OyAT8qS6eA"
//   );
// }
// const token = getStorageSync(CONSTSNT.token);
// axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// axios.defaults.headers['authorization'] = '12222';
axios.defaults.baseURL = Hosts.host;
axios.defaults.headers["Content-Type"] = "application/x-www-form-urlencoded";
axios.defaults.transformRequest = function(data, headers) {
  const token = getStorageSync(constant.token);
  headers.common["Authorization"] = token;
  const da = new FormData();
  if (data) {
    Object.keys(data).forEach((key) => {
      da.append(key, data[key]);
    });
  }

  return da;
};

axios.defaults.transformResponse = function(data, headers) {
  return data && JSON.parse(data);
};

axios.interceptors.response.use(
  function(response) {
    //对返回的数据进行一些处理
    const data = response.data;
    if (Number(data.error_code) === 401) {
      setStorageSync(constant.token, "");
      setStorageSync(constant.userInfo, "");
      // if (router.currentRoute.name !== "scope") {
      //   // todo 写本地页面关闭
      //   router.replace({
      //     name: "scope",
      //     query: { back: router.currentRoute.path },
      //   });
      // }
      router.replace({ name: "Login" });
      // return da;
      return data;
    }

    if (Number(data.error_code) === 2) {
      return data.data;
    } else {
      // todo 错误默认操作
      //console.log(res);

      Falert(data.msg);
      console.log("错误信息:", data.msg);
      return Promise.reject(data.msg);
      // return da;
    }
    return data;
  },
  function(error) {
    Falert("错误代码:" + error.response.status);
    //对返回的错误进行一些处理
    return Promise.reject(error);
  }
);
export { axios as doRequest };
